<template>
<div style="margin: 20px">
  <a-form
      layout="inline"
      :model="formState"
      @finish="handleFinish"
      @finishFailed="handleFinishFailed"
  >
    <a-form-item >
      <span style="user-select: text">例如:WTT Feeder Amman 2023</span>
      <a-input v-model="formState.compName" style="width: 300px" placeholder="CompName">

      </a-input>
    </a-form-item>
    <a-form-item>
      <a-button
          type="primary"
          html-type="submit"
          :disabled="formState.compName === '' || formState.compName === null"
          @click="start_get_score_(formState.compName)"
      >
        start update store
      </a-button>
    </a-form-item>
  </a-form>

<!--  <a-button @click="start_get_score_()">start get score</a-button>-->
  <a-progress :percent="percentage"  />
  <p>{{hinder}}</p>

</div>
</template>

<script>
import {getScoreResult, queryGetScore, startGetScore} from "@/api";
import {reactive} from "vue";
export default {
  name: "Analysis",
  data(){
    return {
      percentage: 0,
      hinder:'',
      query_ttt: null,
      formState:reactive({
        compName:''
      })
    }
  },
  methods:{

    handleFinish ( values)  {
      console.log(values, this.formState.compName);
    },
    handleFinishFailed ( errors)  {
      console.log(errors);
    },
    start_get_score_(name){
      this.start_get_score(name).then((suc)=>{
        if(suc) {
          this.query_ttt = setInterval(() => {
            try {
              this.query_get_score()
            } catch (e) {
              console.log(e)
            }
          }, 2000)
        }
      })

    },
    async start_get_score(name) {
      try{
        const response  = await startGetScore(name)
        if (response.status === 200) {
          if(response.data.success || response.data.success==='True' || response.data.success==='true'){
            this.$store.commit('setCToken',response.data.message)
            return response.data.success
          }
        }
      }catch (e) {
        console.log(e)
      }
    },
    async query_get_score(){
      const response = await queryGetScore(this.$store.state.cToken)
      // console.log(response.data)
      if (response.status === 200) {
        this.percentage =  parseInt(response.data.progress);
        this.hinder = response.data.info
        if(this.percentage===100){
          clearInterval(this.query_ttt)
          this.get_result()
          // console.log('finish')
        }
      }
    },
    async get_result(){
      try{
        const response = await getScoreResult(this.$store.state.cToken)
        console.log(response.data.data)
        if (response.status === 200) {
          if(response.data.success){
            this.$store.commit('setGetScoreRes',response.data.data)
          }
        }
      }catch (e) {
        console.log(e)
      }
    },

  }
}

</script>

<style scoped>

</style>
